module.exports = __webpack_public_path__ + "static/smokin-hero-716948eb72e74f89715d814b45905d04.jpg";